import React from "react";
import styled from "styled-components";
import Skeleton from "react-loading-skeleton";
import "react-loading-skeleton/dist/skeleton.css";
import { get, trim } from "lodash";

const InputWrapper = styled.div`
  width: ${({ width }) => width};
  min-height: ${({ minHeight }) => minHeight};
`;

const LabelWrapper = styled.div`
  opacity: ${({ isLoading }) => (isLoading ? 0 : 0.9)};
  font-family: Roboto;
  font-size: 12px;
  line-height: 1.17;
  text-align: left;
  color: #747576;
  margin-bottom: 3.3px;
`;

const ContentWrapper = styled.div`
  width: 100%;
  height: ${({ height }) => height}px;
  border: ${({ border }) => border};
  border-radius: 4px;
  overflow: hidden;
`;

const Text = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: ${({ justify }) => justify};
  align-items: ${({ align }) => align};

  width: 100%;
  height: 100%;
  border: none;
  background-color: ${({ color }) => color};
  padding: ${({ vPadding }) => vPadding}px ${({ hPadding }) => hPadding}px;

  font-size: 11px;
  font-family: Roboto;
  font-weight: 500;
  color: ${({ textColor }) => textColor};
  resize: none;
`;

const TextArea = Text.withComponent("textarea");

const InputElement = Text.withComponent("input");

const inputTypes = {
  input: InputElement,
  textarea: TextArea,
  text: Text,
};

const Input = (props) => {
  const {
    loading,
    label,
    onChange,
    disabled,
    value,
    defaultValue = "-",
    type = "input", //text, textarea, input
    align = "center",
    color = "#f6f6f6",
    border = "none",
    width = "100%",
    height = 32,
    minHeight = "auto",
    justify = "flex-start",
    loadingMainColor = "#ccc",
    loadingSecondaryColor = "#eee",
    hPadding = 9.5,
    vPadding = 9.5,
    textColor = "#000",
  } = props;

  const Component = get(inputTypes, type, Text);

  const handleChange = ({ target }) => {
    if (onChange) {
      onChange(target.value);
    }
  };

  const renderComponent = () => {
    if (loading) {
      return (
        <Skeleton
          baseColor={loadingMainColor}
          highlightColor={loadingSecondaryColor}
          height="100%"
        />
      );
    }

    if (type === "textarea" || type === "input") {
      return (
        <Component
          disabled={disabled}
          onChange={handleChange}
          align={align}
          color={color}
          justify={justify}
          hPadding={hPadding}
          vPadding={vPadding}
          textColor={textColor}
          value={value || ""}
        />
      );
    }

    return (
      <Component
        disabled
        key={value}
        align={align}
        color={color}
        justify={justify}
        hPadding={hPadding}
        vPadding={vPadding}
        textColor={textColor}
      >
        {trim(value) || defaultValue}
      </Component>
    );
  };

  return (
    <InputWrapper width={width} minHeight={minHeight}>
      {label && <LabelWrapper isLoading={loading}>{label}</LabelWrapper>}
      <ContentWrapper height={height} border={border}>
        {renderComponent()}
      </ContentWrapper>
    </InputWrapper>
  );
};

export default Input;
